<label class="radio">
  <input
    type="radio"
    class="radio__control"
    [name]="name()"
    [value]="radioValue()"
    [ngModel]="value()"
    (change)="onValueChange()"
    (blur)="onTouched()"
  />

  <span class="radio__name">{{ label() }}</span>
</label>
